<template>
    <v-card elevation="0" class="ma-0 pa-0">

        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>

        <popup-move-snapshot-to-folder ref="popup-move-snapshot-to-folder"></popup-move-snapshot-to-folder>
        <popup-edit-snapshot-folder ref="popup-edit-snapshot-folder"></popup-edit-snapshot-folder>
        <popup-edit-string ref="popup-edit-string"></popup-edit-string>
        <popup-upload-snapshots ref="popup-upload-snapshots"></popup-upload-snapshots>

        <v-card-actions class="ma-0 pa-0">
            <v-card elevation="0" outlined width="100%" class="mb-2">
                <v-card-actions>
                    <v-card color="orange" elevation="0" class="ma-0 pa-2 white--text" outlined>Snapshots: {{snapshotsCount}}</v-card>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!ifCanImportSave()"
                           :loading="importing"
                           elevation="0"
                           color="blue"
                           class="white--text"
                           @click="onPressImportSave">
                        Import Zip with shapshots
                        <v-icon size="20" class="ml-2">mdi-database-import-outline</v-icon>
                    </v-btn>
                    <input ref="uploader"
                           class="d-none"
                           type="file"
                           accept=".zip"
                           @change="onFileChanged">
                </v-card-actions>
            </v-card>
        </v-card-actions>

        <v-card-actions class="ma-0 pa-0">
            <v-card outlined elevation="0" width="100%">
                <v-card-actions>
                    <v-text-field
                            style="margin-bottom: -30px;"
                            v-model="tempFindData"
                            label="Search"
                            placeholder="Enter keyword to searchs in names"
                            outlined
                            clearable
                            append-icon="mdi-magnify"
                            @click:append="searchSnapshot"
                            @keyup.enter="searchSnapshot"
                    ></v-text-field>

                </v-card-actions>
            </v-card>
        </v-card-actions>

        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card elevation="0" width="100%">
                <v-card-actions class="ma-0 pa-0">
                    <v-slide-group
                            class="pa-0"
                            show-arrows>
                        <v-slide-item v-for="folder in folders" :key="folder.fid">
                            <v-card v-if="folder.fid != 'add'"
                                    outlined
                                    elevation="0"
                                    class="mr-2"
                                    height="60"
                                    width="120">
                                <v-container class="ma-0 pa-0">
                                    <v-col>
                                        <v-row>
                                            <v-card elevation="0" height="22px" width="100%">
                                                <p style="font-size: 0.8em; margin-left: 10px; margin-top: 3px">
                                                    {{ folder.name }}</p>
                                            </v-card>
                                        </v-row>
                                        <v-row>
                                            <v-card elevation="0" height="35px" width="100%">
                                                <v-card-actions class="ma-0 pa-0">
                                                    <v-btn icon color="black" @click="onPressCheckFolder(folder)">
                                                        <v-icon size="22">
                                                            {{ isSelected(folder) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                                                        </v-icon>
                                                    </v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn v-if="folder.fid != 'all'" icon color="green"
                                                           @click="onPressEditFolder(folder)">
                                                        <v-icon size="22">mdi-pencil</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-row>
                                    </v-col>
                                </v-container>
                            </v-card>
                            <v-card v-else
                                    elevation="0"
                                    class="mr-2"
                                    height="60"
                                    width="60">
                                <v-btn elevation="0" color="green" width="60px" height="60px" @click="addFolder()">
                                    <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                            </v-card>
                        </v-slide-item>
                    </v-slide-group>
                </v-card-actions>
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card outlined width="100%">
                <v-card-actions class="ma-0 pa-0">
                    <v-data-table
                            style="width: 100%;"
                            fixed-header
                            :items="snapshots"
                            :headers="headers"
                            hide-default-footer
                            :sort-by="['created']"
                            :sort-desc="true"
                            disable-pagination>
                        <template v-slot:item.created="{ item }">
                            <v-card-text>{{ item.created | formatDateISO }}</v-card-text>
<!--                            <v-card-text>{{ item.created }}</v-card-text>-->
                        </template>
                        <template v-slot:item.name="{ item }">
                            <v-btn outlined
                                   color="green"
                                   class="mr-1"
                                   @click="onPressEditName(item)">
                                {{ item.name || "no name" }}
                            </v-btn>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip bottom max-width="50%">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                           color="orange"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="ma-0 pa-0"
                                           @click="onPressInfo(item)">
                                        <v-icon size="22">mdi-information</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ item.info != undefined && item.info.length != 0 ? item.info : "no info" }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                           color="blue"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="ma-0 pa-0"
                                           @click="onPressMoveToFolder(item)">
                                        <v-icon size="22">mdi-folder-move</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ item.info != undefined && item.info.length != 0 ? item.info : "no info" }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="deleting == item.id"
                                           icon
                                           color="red"
                                           v-bind="attrs"
                                           v-on="on"
                                           class="mr-1"
                                           @click="onPressDelete(item)">
                                        <v-icon size="22">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete snapshot</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-actions>
            </v-card>
        </v-card-actions>
    </v-card>
</template>

<script>

import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import PopupEditString from "@/modules/common/popup-edit-string";
import {FolderModel} from "@/modules/mprofiles/models/FolderModel";
import firebase from "firebase";
import PopupEditSnapshotFolder from "@/modules/mprofiles/views/find-user/popups/popup-edit-snapshot-folder";
import PopupMoveSnapshotToFolder from "@/modules/mprofiles/views/find-user/popups/popup-move-snapshot-to-folder";
import PopupUploadSnapshots from "@/modules/mprofiles/views/find-user/popups/popup-upload-snapshots";

export default {
    name: "p-saves",
    components: {PopupUploadSnapshots, PopupMoveSnapshotToFolder, PopupEditSnapshotFolder, PopupEditString},
    data: () => ({
        loading: true,
        deleting: "",
        importing: false,
        tempFindData: '',
        findData: '',
        headers: [
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red"},
            {text: 'Player Id', sortable: true, value: 'player_id', class: "white blue--text", color: "red"},
            {text: 'Level', sortable: true, value: 'level', class: "white blue--text", color: "red"},
            {text: 'Created', sortable: true, value: 'created', class: "white blue--text", color: "red"},
            {text: 'User Id', sortable: true, value: 'user_id', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width: '15%', align: 'end'}
        ],
        selectedFolders: [],
    }),
    mounted() {
        this.loading = true;
        UsersBackendUtils.fetchSnapFolders().then(() => {
            this.$notify({title: 'Folders successfully fetched!', type: "success"});
            UsersBackendUtils.fetchUsersSnapshots().then(() => {
                this.$notify({title: 'Snapshots successfully fetched!', type: "success"});
                this.loading = false;
            }).catch((error) => {
                this.$notify({title: 'Snapshots fetch failed!', text: error, type: "error"});
                this.false = false;
            })
        }).catch((error) => {
            this.$notify({title: 'Folders fetch failed!', text: error, type: "error"});
            this.false = false;
        })
    },
    methods: {
        isSelected(folder) {
            let index = this.selectedFolders.findIndex(fid => {
                return fid == folder.fid;
            })
            return index >= 0;
        },
        addFolder() {
            this.$refs['popup-edit-string'].show("", (folderName) => {
                if (folderName.length == 0) {
                    this.$notify({title: 'Empty folder name', type: "error"});
                    return;
                }
                this.loading = true;
                UsersBackendUtils.createSnapFolder({
                    "name": folderName,
                    "created_by": firebase.auth().currentUser.uid,
                    "info": ""
                }).then(() => {
                    this.loading = false;
                    this.$notify({title: 'Info successfully updated!', type: "success"});
                }).catch((error) => {
                    this.loading = false;
                    this.$notify({title: 'Info update failed!', text: error, type: "error"});
                })
            }, false)
        },
        onPressCheckFolder(folder) {
            let index = this.selectedFolders.findIndex(fid => {
                return fid == folder.fid;
            });
            if (index >= 0) {
                this.selectedFolders.splice(index, 1);
            } else {
                this.selectedFolders.push(folder.fid)
            }
        },
        onPressEditFolder(folder) {
            this.$refs['popup-edit-snapshot-folder'].show(folder);
        },
        onPressMoveToFolder(snapshot) {
            this.$refs['popup-move-snapshot-to-folder'].show(snapshot);
        },
        onPressInfo(item) {
            this.$refs['popup-edit-string'].show(item.info, (newInfo) => {
                UsersBackendUtils.updateSnapshotInfo({"snapId": item.id, "info": newInfo}).then(() => {
                    this.$notify({title: 'Info successfully updated!', type: "success"});
                }).catch((error) => {
                    this.$notify({title: 'Info update failed!', text: error, type: "error"});
                })
            }, true)
        },
        onPressEditName(item) {
            this.$refs['popup-edit-string'].show(item.name, (newName) => {
                UsersBackendUtils.updateSnapshotInfo({"snapId": item.id, "name": newName}).then(() => {
                    this.$notify({title: 'Name successfully updated!', type: "success"});
                }).catch((error) => {
                    this.$notify({title: 'Name update failed!', text: error, type: "error"});
                })
            }, false);
        },
        onPressDelete(item) {
            this.$confirm("Are you sure?").then(() => {
                this.deleting = item.id;
                UsersBackendUtils.deleteUserSnapshots([item.id]).then(() => {
                    this.$notify({title: 'Snapshot successfully deleted!', type: "success"});
                    this.deleting = ""
                }).catch((error) => {
                    this.deleting = ""
                    this.$notify({title: 'Snapshot delete failed!', text: error, type: "error"});
                })
            }).catch(() => {
            })
        },
        searchSnapshot() {
            this.findData = this.tempFindData;
        },
        getMyUserUid() {
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanImportSave() {
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.USERS_TAB.subpermissions.USERS_TAB_IMPORT_SAVE.id)
        },
        onFileChanged(e) {
            this.$refs['popup-upload-snapshots'].show(e.target.files[0]);
        },
        onPressImportSave() {
            window.addEventListener('focus', () => {
            }, {once: true})
            this.$refs.uploader.click()
        },
    },
    computed: {
        folders() {
            let folders = [];
            let allModel = new FolderModel();
            allModel.name = "All";
            allModel.fid = "all"
            allModel.snapshots = UsersBackendUtils.getSnapshots().map(e => e.id);
            folders.push(allModel)
            folders = folders.concat(UsersBackendUtils.getFolders().map(e => e.copy()));
            let addModel = new FolderModel();
            addModel.fid = "add"
            folders.push(addModel)
            return folders;
        },
        snapshotsCount() {
            return UsersBackendUtils.getSnapshots().length
        },
        snapshots() {
            var final = []
            let allShapshots = UsersBackendUtils.getSnapshots();
            for (let i in this.folders) {
                let folder = this.folders[i];
                if (this.isSelected(folder)) {
                    for (let j in folder.snapshots) {
                        let id = folder.snapshots[j];
                        final = final.concat(allShapshots.filter(e => e.id == id))
                    }
                }
            }
            let uniqueSnapshots = [...new Set(final)];
            if (this.findData == undefined || this.findData == null || this.findData.length == 0) {
                return uniqueSnapshots;
            }
            let text = this.findData;
            let newArray = uniqueSnapshots.filter(function (el) {
                return el.name.toLowerCase().indexOf(text) >= 0;
            });
            return newArray;
        }
    }
}
</script>

<style scoped>
</style>